import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import LeftNewsBox from './leftNewsBox';
import CenterNewsBox from './centerNewsBox';
import RightNewsBox from './rightNewsBox';

class NewsBox5 extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { leftData, centerData, rightData, houseHardAd },
        } = this.props;

        return (
            <div className={styles.news_box}>
                <LeftNewsBox content={leftData} />
                <div className={styles.box_r}>
                    <div className="clearfix">
                        <CenterNewsBox content={centerData} />
                        <RightNewsBox content={rightData} />
                    </div>
                    <NoSSR>
                        <Ad content={houseHardAd} styleName={styles.d_box} />
                    </NoSSR>
                </div>
            </div>
        );
    }
}

export default errorBoundary(NewsBox5);
